module.exports = __webpack_public_path__ + "img/STATISTICS_PROBABILITY.a948de2f.png";